import { useTranslation } from "react-i18next";
import { COMPANY_OWNERSHIP_SETTINGS, companyFooterStatement, companyOwnershipStatement } from "@contracts/company-ownership";
import { usePublicSite } from "@/public-site-context";

export default function CompanyOwnershipStatement({ className = "", full = false }: { className?: string; full?: boolean }) {
  const { i18n } = useTranslation();
  const language = i18n.language.startsWith("ar") ? "ar" : "en";
  const domain = usePublicSite();
  const settings = { ...COMPANY_OWNERSHIP_SETTINGS, website: domain };
  return <p data-company-ownership className={className}>{full ? companyFooterStatement(settings, language) : companyOwnershipStatement(settings, language)}</p>;
}
